import { LANG } from '@/constants';
import store from "@/store";

export const nameTranslate = (item) => {
  const lang = store.getters['settings/lang'];
  let { name } = item;

  if(item.translated_names) {
    if(lang === LANG.EN && item.translated_names[LANG.EN.toLowerCase()]) {
      name = item.translated_names[LANG.EN.toLowerCase()];
    } else if(lang === LANG.UA && item.translated_names[LANG.UA.toLowerCase()]) {
      name = item.translated_names[LANG.UA.toLowerCase()];
    } else if(lang === LANG.RU && item.translated_names[LANG.RU.toLowerCase()]) {
      name = item.translated_names[LANG.RU.toLowerCase()];
    }
  }
  return name;
};
